import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityCommentInput = () => {
  const { commentId = '' } = useParams();
  const decodedId = commentId ? atob(commentId) : commentId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityComment';

  useEffect(() => {
    if (commentId) { setIsEditing(true); fetchDetails(); }
  }, [commentId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityComment'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Comment details:', error); }
  };

  const fields = [{"name":"opportunity","label":"Opportunity","type":"number"},{"name":"comment","label":"Comment","type":"textarea"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Comment' : 'Create Opportunity Comment'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityCommentInput;